import React, { useEffect, useState } from "react"
import { Button, Descriptions, Divider, Drawer, Input, InputNumber, Typography } from "antd"
import { SplitCellsOutlined } from "@ant-design/icons"
import { SplitOrderFunction } from "./SplitOrderFunction"
import { useAuthContext } from "../../../hooks/useAuthContext"

const { TextArea } = Input

const { Text } = Typography

export default function SplitOrderDrawer({ orderData, rollData, disabled }) {
  const { user } = useAuthContext()
  const [open, setOpen] = useState(false)
  //label counts
  const [firstOrderCount, setFirstOrderCount] = useState(0)
  const [secondOrderLabelCount, setSecondOrderLabelCount] = useState(0)

  // //rolls for first order
  // const [rollIdsForFirstOrder, setRollIdsForFirstOrder] = useState([]);
  // //rolls for second order
  // const [rollIdsForSecondOrder, setRollIdsForSecondOrder] = useState([]);

  //user comment on split
  const [userSplitComment, setUserSplitComment] = useState("")

  // //disable split button
  // const [disableSplit, setDisableSplit] = useState(true);

  //loading spin
  const [loadingSpin, setLoadingSpin] = useState(false)

  const showDrawer = () => {
    setOpen(true)
  }
  const onClose = () => {
    setOpen(false)
  }

  //handle first order label count
  const handleFirstOrderLabelCount = (value) => {
    setFirstOrderCount(value)
  }

  // //useEffect that disables split button on certain scneraios
  // useEffect(() => {
  //   if (rollIdsForSecondOrder.length === 0 || rollIdsForFirstOrder.length === 0) {
  //     setDisableSplit(true);
  //   } else {
  //     setDisableSplit(false);
  //   }
  // }, [rollIdsForSecondOrder, rollIdsForFirstOrder]);

  //use effect that controlls the label count for second order
  useEffect(() => {
    let totalLabelCount = orderData.labelCount

    setSecondOrderLabelCount(totalLabelCount - firstOrderCount)
  }, [firstOrderCount, orderData])

  // //handle roll send
  // const handleRollSendSelect = (value, item) => {
  //   // Updating the roll IDs for the first order
  //   setRollIdsForFirstOrder((prevRollIds) => {
  //     // If the selected value is 1 or 0, it means we want to assign this roll to the first order
  //     // So, we first remove this roll ID from the list (if it exists), to avoid duplicate entries, and then add it to the list
  //     if (value === 1 || value === 0) {
  //       return [...prevRollIds.filter((id) => id !== item.id), item.id];
  //     }
  //     // If the selected value is not 1 or 0, it means we want to remove this roll from the first order
  //     // So, we remove this roll ID from the list (if it exists)
  //     else {
  //       return prevRollIds.filter((id) => id !== item.id);
  //     }
  //   });

  //   // Updating the roll IDs for the second order
  //   setRollIdsForSecondOrder((prevRollIds) => {
  //     // If the selected value is 2 or 0, it means we want to assign this roll to the second order
  //     // So, we first remove this roll ID from the list (if it exists), to avoid duplicate entries, and then add it to the list
  //     if (value === 2 || value === 0) {
  //       return [...prevRollIds.filter((id) => id !== item.id), item.id];
  //     }
  //     // If the selected value is not 2 or 0, it means we want to remove this roll from the second order
  //     // So, we remove this roll ID from the list (if it exists)
  //     else {
  //       return prevRollIds.filter((id) => id !== item.id);
  //     }
  //   });
  // };

  return (
    <div>
      <Button
        disabled={disabled}
        size="small"
        icon={<SplitCellsOutlined />}
        type="primary"
        onClick={showDrawer}>
        Split Order
      </Button>
      <Drawer width={800} title="Split order" placement="right" onClose={onClose} open={open}>
        <Divider>Split info</Divider>
        <Text>
          This function allows you to split this current order into two by splitting label count and
          assigning rolls to each order.
          <Text strong style={{ color: "red" }}>
            Use this with caution.
          </Text>
        </Text>
        <Divider>Split Details</Divider>
        <Descriptions column={1}>
          <Descriptions.Item label="Total label count">{orderData.labelCount}</Descriptions.Item>
          <Descriptions.Item label="Label count for first order">
            <InputNumber
              size="small"
              style={{ width: "100%" }}
              value={firstOrderCount}
              onChange={handleFirstOrderLabelCount}
            />
          </Descriptions.Item>
          <Descriptions.Item label="Remaining count for second order">
            <InputNumber size="small" style={{ width: "100%" }} value={secondOrderLabelCount} />
          </Descriptions.Item>
        </Descriptions>
        {/* <Divider>Roll Details</Divider>
        <List
          itemLayout="horizontal"
          bordered
          dataSource={rollData && rollData}
          renderItem={(item, index) => (
            <List.Item
              actions={[
                <Space style={{ width: "100%" }}>
                  <Text style={{ color: "red" }}>Send to</Text>
                  <Select
                    onChange={(value) => handleRollSendSelect(value, item)}
                    style={{ width: 120 }}
                    options={[
                      {
                        label: "first order",
                        value: 1,
                      },
                      {
                        label: "second order",
                        value: 2,
                      },
                      {
                        label: "both orders",
                        value: 0,
                      },
                    ]}
                  />
                </Space>,
              ]}
            >
              <List.Item.Meta
                title={<Text copyable={{ text: item.id }}>Roll id : {item.id}</Text>}
                description={
                  <Space size="small" split={<Divider type="vertical" />}>
                    <Text>
                      Material : <Tag color="blue">{item.material.material}</Tag>
                    </Text>
                    <Text>
                      Width : <Tag color="blue">{item.rollWidth}</Tag>
                    </Text>
                    <Text>
                      Remaining Meters : <Tag color="blue">{item.remainingMeters}</Tag>
                    </Text>
                  </Space>
                }
              />
            </List.Item>
          )}
        /> */}
        <Divider>Comment on split</Divider>
        <TextArea
          rows={5}
          value={userSplitComment}
          onChange={(event) => setUserSplitComment(event.target.value)}
        />
        <Button
          loading={loadingSpin}
          onClick={() =>
            SplitOrderFunction(
              orderData,
              firstOrderCount,
              secondOrderLabelCount,
              userSplitComment,
              user,
              rollData,
              setLoadingSpin
            )
          }>
          Split Order
        </Button>
      </Drawer>
    </div>
  )
}
